<nz-spin [nzSpinning]="loading">
  <section class=" preview-custom-two">
    <div class="container">
      <div class="grid grid-cols-1">
        <div class="relative w-full h-[45.5rem] overflow-hidden pl-6">
          <!-- SVG Clip Path -->
          <svg class="absolute bottom-0 left-0 w-full h-full">
            <defs>
              <clipPath id="curveClip" clipPathUnits="objectBoundingBox">
                <path d="M0,0 H1 V0.85 Q0.5,1 0,0.85 Z"></path>
              </clipPath>
            </defs>
          </svg>

          <!-- Image with Clipping -->
          <img loading="lazy" [src]="data?.featured?.image" class="absolute inset-0 w-full h-full object-cover"
               style="clip-path: url(#curveClip);" alt="Curved Cutout">
          <div style="clip-path: url(#curveClip);"
               class="absolute inset-0 bg-gradient-to-r from-black/25 to-transparent pointer-events-none">
          </div>

          <!-- Text Overlay -->
          <div class="hidden md:flex items-center justify-start h-full relative">

            <div class="relative flex flex-col z-40 justify-center items-start pl-2">
              <!-- subtle gradient overlay -->
              <div *ngIf="this.data?.title && !data?.viewSettings?.isItineraryTitleChecked">
                <h4 class="text-white font-normal">
                  {{ this.data?.title }}
                </h4>
              </div>
              <span class="text-[4rem] text-white">
                {{ data?.days.length | number:'2.0' }}
                {{ this.localizationContent?.days }} /
                {{ (data?.days.length - 1) | number:'2.0' }}
                {{ this.localizationContent?.nights }}
              </span>
              <div *ngIf="this.countries.length !== 0" class="flex flex-row mt-2">
                <div *ngFor="let country of this.countries">
                  <h4 class="pr-3 text-white font-normal">
                    {{ country }}
                  </h4>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="container">
      <div class="grid grid-cols-1 space-y-[20px] md:space-y-[40px]">
        <div class="bg-white space-y-[20px]">
          <div class="md:hidden block">
            <div *ngIf="this.data?.title && !data?.viewSettings?.isItineraryTitleChecked">
              <p class="font-extralight">{{this.data?.title}}</p>
            </div>
            <div>
              <span class="text-[2.25rem] font-semibold">
                {{ data?.days.length | number : '2.0' }} {{this.localizationContent?.days}} /
                {{ data?.days.length - 1 | number : '2.0' }} {{this.localizationContent?.nights}}
              </span>
            </div>
            <div>
              <div
                *ngIf="this.countries.length !== 0"
                class="flex flex-row mb-2">
                <div *ngFor="let country of this.countries">
                  <span
                    class="pe-3 font-extralight">
                    {{ country }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="hidden md:block">
            <div class="grid  lg:grid-cols-3 grid-cols-2 gap-5">
              <div *ngIf="!this.data?.viewSettings.isCustomerInformationChecked && this.data?.tour?.customer">
                <p class="text-[#B7B7B7] font-normal text-[1.5rem]"> {{this.localizationContent?.client_information}}</p>
                <div class="flex flex-row gap-2">
                  <p class="text-[#444444]">{{this.localizationContent?.name}}: </p>
                  <p
                    class="text-[#444444]">{{ this.data.tour.customer.first_name + " " + this.data.tour.customer.last_name }}</p>
                </div>
                <div class="flex flex-row gap-2">
                  <p class="text-[#444444]">{{this.localizationContent?.email}}: </p>
                  <p
                    class="text-[#444444]">{{ this.data.tour.customer?.email ? this.data.tour.customer?.email : "-" }}</p>
                </div>
                <div class="flex flex-row gap-2">
                  <p class="text-[#444444]">{{this.localizationContent?.country}}: </p>
                  <img loading="lazy" height="20px" width="20px"
                       [src]="this.findCountryFlagImage(this.data?.tour.customer.country.code)"
                       alt="country">
                  <p class="text-[#444444]">{{ this.data.tour.customer.country.name }}</p>
                </div>
              </div>
              <div>
                <p class="text-[#B7B7B7] font-normal text-[1.5rem]">{{this.localizationContent?.tour_information}}</p>
                <div class="flex flex-row gap-2" *ngIf="!this.data.tour.isDatesOptional">
                  <p class="text-[#444444]">{{this.localizationContent?.dates}}: </p>
                  <p
                    class="text-[#444444]">{{ this.customizeDate(this.data?.tour?.startDate, 'Do MMM, YYYY') + " - " + this.customizeDate(this.data?.tour?.endDate, 'Do MMM, YYYY') }}</p>
                </div>
                <div class="flex flex-row gap-2">
                  <p class="text-[#444444]">{{this.localizationContent?.number_of_pax}}: </p>
                  <p class="text-[#444444]" *ngIf="this.data?.tour?.pax.adults !== 0">{{ this.data?.tour?.pax.adults | number : '2.0' }} <span
                    class="ml-0.5 text-[12px]">{{this.localizationContent?.adults}}</span></p>
                  <p class="text-[#444444]" *ngIf="this.data?.tour?.pax.children !== 0">{{ this.data?.tour?.pax.children | number : '2.0' }} <span
                    class="ml-0.5 text-[12px]">{{this.localizationContent?.children}}</span></p>
                  <p class="text-[#444444]" *ngIf="this.data?.tour?.pax.infants !== 0">{{ this.data?.tour?.pax.infants | number : '2.0' }} <span
                    class="ml-0.5 text-[12px]">{{this.localizationContent?.infant}}</span></p>

                </div>
              </div>
              <div *ngIf="!this.data?.costSettings?.isDynamicPricing">
              <!--          with cost breakdown b2c-->
              <div *ngIf="!this.data?.viewSettings.isTourCostHidden && this.data?.costing?.viewType === 'custom' &&
                (this.data?.costing?.costPerAdult !==0 || this.  data?.costing?.costPerInfant !==0 || this.data?.costing?.costPerChild) && this.isClientUrl">
                <p class="text-[#B7B7B7] font-normal text-[1.5rem]">{{this.localizationContent?.cost_per_person}}</p>
                <div class="flex flex-col md:flex-row gap-5 mt-3">
                  <div *ngIf="this.data?.costing?.costPerAdult !==0 && this.data?.costing?.costPerAdult !== null"
                       class="flex md:flex-col flex-row leading-7 gap-2">
                <span class="text-[20px]" style="font-weight: normal !important">
                  {{ this.data?.tour?.currency }}
                  <span class="font-semibold">{{
                      this.data?.costing?.costPerAdult | number:'1.2-2'
                    }}</span>
                </span>
                    <span
                      class="md:ml-0 md:mt-0 font-light flex justify-start md:justify-end items-center text-[#454545] text-[12px]"
                    >{{this.localizationContent?.per_adult}}</span>
                  </div>
                  <div *ngIf="this.data?.costing?.costPerChild !==0  && this.data?.costing?.costPerChild !== null"
                       class="flex md:flex-col flex-row leading-7 gap-2">
                 <span class="text-[20px]" style="font-weight: normal !important">
                  {{ this.data?.tour?.currency }}
                   <span class="font-semibold">{{
                       this.data?.costing?.costPerChild | number:'1.2-2'
                     }}</span>
                 </span>
                    <span
                      class="md:ml-0 md:mt-0 font-light flex justify-start md:justify-end items-center text-[#454545] text-[12px]"
                    >{{this.localizationContent?.per_child}}</span
                    >
                  </div>
                  <div *ngIf="this.data?.costing?.costPerInfant !==0 && this.data?.costing?.costPerInfant !== null"
                       class="flex md:flex-col flex-row leading-7 gap-2">
                 <span class="text-[20px]" style="font-weight: normal !important">
                  {{ this.data?.tour?.currency }}
                   <span class="font-semibold">{{
                       this.data?.costing?.costPerInfant  | number:'1.2-2'
                     }}</span>
                 </span>
                    <span
                      class="md:ml-0 md:mt-0 font-light flex justify-start md:justify-end items-center text-[#454545] text-[12px]"
                    >{{this.localizationContent?.per_infant}}</span
                    >
                  </div>
                </div>
                <div
                  *ngIf="!this.data?.viewSettings.isPaymentLinkChecked && this.data?.paymentLink !=='' && this.data?.paymentLink !==null">
                  <button
                    class="payment-button">
                    <span>
                      <a
                        href="{{ this.data?.paymentLink }}"
                        target="_blank"
                        rel="noopener noreferrer"
                      >{{this.localizationContent?.pay_now}}</a
                      >
                    </span>
                  </button>
                </div>
              </div>
              <!--          without cost breakdown b2c-->
              <div *ngIf="this.data?.costing?.personCost !== 0 &&
            !this.data?.viewSettings.isTourCostHidden && this.data?.costing?.viewType !== 'custom' && this.isClientUrl">
                <p class="text-[#B7B7B7] font-normal text-[1.5rem]">
                  {{ this.data?.costing?.viewType === 'person' ? this.localizationContent?.cost_per_person : this.localizationContent?.total_tour_cost}}
                </p>
                <div class="flex md:flex-col flex-row leading-9">
                  <p>
                    {{ this.data?.tour?.currency }}
                    <span class="font-semibold">
                      {{
                        (this.data?.costing?.viewType === 'person' ? this.data?.costing?.personCost  : this.data?.costing?.grandTotal) | number:'1.2-2'
                      }}
                    </span>
                  </p>
                </div>
                <div
                  *ngIf="!this.data?.viewSettings.isPaymentLinkChecked && this.data?.paymentLink !=='' && this.data?.paymentLink !==null">
                  <button
                    class="payment-button">
                    <span>
                      <a
                        href="{{ this.data?.paymentLink }}"
                        target="_blank"
                        rel="noopener noreferrer"
                      >{{this.localizationContent?.pay_now}}</a
                      >
                    </span>
                  </button>
                </div>
              </div>

              <!--          with cost breakdown b2c-->
              <div
                *ngIf="!this.data?.viewSettings.isTourCostHidden && this.data?.b2b?.costing?.viewType ==='custom' && !this.isClientUrl">
                <p class="text-[#B7B7B7] font-normal text-[1.5rem]">
                  {{this.localizationContent?.cost_per_person}}
                </p>
                <div class="flex flex-col md:flex-row gap-5 mt-3">
                  <div class="flex md:flex-col flex-row leading-7">
                <span class="text-[20px]" style="font-weight: normal !important">
                  {{ this.data?.tour?.currency }}
                  <span class="font-semibold">{{
                      this.data?.b2b?.costing?.costPerAdult | number:'1.2-2'
                    }}</span>
                </span>
                    <span
                      class="ml-3 md:ml-0 mt-3 md:mt-0 font-light flex justify-start md:justify-end items-center text-[#454545] text-[12px]"
                    >{{this.localizationContent?.per_adult}}</span
                    >
                  </div>
                  <div class="flex md:flex-col flex-row leading-7">
                 <span class="text-[20px]" style="font-weight: normal !important">
                  {{ this.data?.tour?.currency }}
                   <span class="font-semibold">{{
                       this.data?.b2b?.costing?.costPerChild | number:'1.2-2'
                     }}</span>
                 </span>
                    <span
                      class="ml-3 md:ml-0 mt-3 md:mt-0 font-light flex justify-start md:justify-end items-center text-[#454545] text-[12px]"
                    >{{this.localizationContent?.per_child}}</span
                    >
                  </div>
                  <div class="flex md:flex-col flex-row leading-7">
                 <span class="text-[20px]" style="font-weight: normal !important">
                  {{ this.data?.tour?.currency }}
                   <span class="font-semibold">{{
                       this.data?.b2b?.costing?.costPerInfant  | number:'1.2-2'
                     }}</span>
                 </span>
                    <span
                      class="ml-3 md:ml-0 mt-3 md:mt-0 font-light flex justify-start md:justify-end items-center text-[#454545] text-[12px]"
                    >{{this.localizationContent?.per_infant}}</span
                    >
                  </div>
                </div>
              </div>
              <!--          without cost breakdown b2b-->
              <div *ngIf="
            (this.data?.b2b?.costing?.personCost !== 0 || this.data?.b2b?.costing?.grandTotal !== 0) &&
            !this.data?.viewSettings.isTourCostHidden && this.data?.b2b?.costing?.viewType !=='custom'  && !this.isClientUrl">
                <p class="text-[#B7B7B7] font-normal text-[1.5rem]">
                  {{this.data?.b2b?.costing?.viewType === 'person' ? this.localizationContent?.cost_per_person : this.localizationContent?.total_tour_cost}}
                <p>
                <div class="flex md:flex-col flex-row leading-9">
                  <p>
                    {{ this.data?.tour?.currency }}
                    <span class="font-semibold">
                      {{
                        (this.data?.b2b.costing?.viewType === 'person' ? this.data?.b2b.costing?.personCost  : this.data?.b2b.costing?.grandTotal) | number:'1.2-2'
                      }}
                    </span>
                  </p>
                </div>
              </div>
              </div>
              </div>
          </div>

          <div class="block md:hidden mb-8">
            <swiper-container #swiperRef  class="swiper-exp"
                              space-between="15"
                              slides-per-view="auto"
                              pagination="false"
                              speed="250"
                              loop="false">
              <swiper-slide class="mb-6 p-2.5 bg-[#F8F8F8] rounded-[10px]"
                            *ngIf="!this.data?.viewSettings.isCustomerInformationChecked && this.data?.tour?.customer">
                <div class="min-h-[11rem]">
                  <p class="text-[#B7B7B7] font-normal text-[1.5rem]"> {{this.localizationContent?.client_information}}</p>
                  <div class="flex flex-row gap-2">
                    <p class="text-[#444444]">{{this.localizationContent?.name}}: </p>
                    <p
                      class="text-[#444444]">{{ this.data.tour.customer.first_name + " " + this.data.tour.customer.last_name }}</p>
                  </div>
                  <div class="flex flex-row gap-2">
                    <p class="text-[#444444]">{{this.localizationContent?.email}}: </p>
                    <p
                      class="text-[#444444]">{{ this.data.tour.customer?.email ? this.data.tour.customer?.email : "-" }}</p>
                  </div>
                  <div class="flex flex-row gap-2">
                    <p class="text-[#444444]">{{this.localizationContent?.country}}: </p>
                    <img loading="lazy" height="20px" width="20px"
                         [src]="this.findCountryFlagImage(this.data?.tour.customer.country.code)"
                         alt="country">
                    <p class="text-[#444444]">{{ this.data.tour.customer.country.name }}</p>
                  </div>
                </div>
              </swiper-slide>

              <swiper-slide class="mb-8 p-2.5 bg-[#F8F8F8] rounded-[10px]">
                <div class="min-h-[11rem]">
                  <p class="text-[#B7B7B7] font-normal text-[1.5rem]">{{this.localizationContent?.tour_information}}</p>
                  <div class="flex flex-row gap-2">
                    <p class="text-[#444444]">{{this.localizationContent?.dates}}: </p>
                    <p
                      class="text-[#444444]">{{ this.customizeDate(this.data?.tour?.startDate, 'Do MMM, YYYY') + " - " + this.customizeDate(this.data?.tour?.endDate, 'Do MMM, YYYY') }}</p>
                  </div>
                  <div class="flex flex-row gap-2">
                    <p class="text-[#444444]">{{this.localizationContent?.number_of_pax}}: </p>
                    <p class="text-[#444444]">{{ this.data?.tour?.pax.adults | number : '2.0' }} <span
                      class="ml-0.5 text-[12px]">{{this.localizationContent?.adults}}</span></p>
                    <p class="text-[#444444]">{{ this.data?.tour?.pax.children | number : '2.0' }} <span
                      class="ml-0.5 text-[12px]">{{this.localizationContent?.children}}</span></p>
                    <p class="text-[#444444]">{{ this.data?.tour?.pax.infants | number : '2.0' }} <span
                      class="ml-0.5 text-[12px]">{{this.localizationContent?.infant}}</span></p>

                  </div>
                </div>
              </swiper-slide>


              <!--          with cost breakdown b2c-->
              <swiper-slide class="mb-6 p-2.5 bg-[#F8F8F8] rounded-[10px]"
                            *ngIf="!this.data?.costSettings?.isDynamicPricing && !this.data?.viewSettings.isTourCostHidden && this.data?.costing?.viewType === 'custom' &&
            (this.data?.costing?.costPerAdult !==0 || this.  data?.costing?.costPerInfant !==0 || this.data?.costing?.costPerChild) && this.isClientUrl">
                <div class="min-h-[11rem]">
                  <p class="text-[#B7B7B7] font-normal text-[1.5rem]">{{this.localizationContent?.cost_per_person}}</p>
                  <div class="flex flex-col md:flex-row mt-3">
                    <div *ngIf="this.data?.costing?.costPerAdult !==0 && this.data?.costing?.costPerAdult !== null"
                         class="flex md:flex-col flex-row leading-7 gap-2">
                      <p>
                        {{ this.data?.tour?.currency }}
                        <span class="font-semibold">{{
                            this.data?.costing?.costPerAdult | number:'1.2-2'
                          }}</span>
                      </p>
                      <span
                        class="md:ml-0  md:mt-0 font-light flex justify-start md:justify-end items-center text-[#454545] text-[12px]"
                      >{{this.localizationContent?.per_adult}}</span
                      >
                    </div>
                    <div *ngIf="this.data?.costing?.costPerChild !==0  && this.data?.costing?.costPerChild !== null"
                         class="flex md:flex-col flex-row leading-7 gap-2">
                      <p>
                        {{ this.data?.tour?.currency }}
                        <span class="font-semibold">{{
                            this.data?.costing?.costPerChild | number:'1.2-2'
                          }}</span>
                      </p>
                      <span
                        class="md:ml-0  md:mt-0 font-light flex justify-start md:justify-end items-center text-[#454545] text-[12px]"
                      >{{this.localizationContent?.per_child}}</span
                      >
                    </div>
                    <div *ngIf="this.data?.costing?.costPerInfant !==0 && this.data?.costing?.costPerInfant !== null"
                         class="flex md:flex-col flex-row leading-7 gap-2">
                      <p>
                        {{ this.data?.tour?.currency }}
                        <span class="font-semibold">{{
                            this.data?.costing?.costPerInfant  | number:'1.2-2'
                          }}</span>
                      </p>
                      <span
                        class="md:ml-0  md:mt-0 font-light flex justify-start md:justify-end items-center text-[#454545] text-[12px]"
                      >{{this.localizationContent?.per_infant}}</span
                      >
                    </div>
                  </div>
                  <div
                    *ngIf="!this.data?.viewSettings.isPaymentLinkChecked && this.data?.paymentLink !=='' && this.data?.paymentLink !==null">
                    <button
                      class="payment-button">
                    <span>
                      <a
                        href="{{ this.data?.paymentLink }}"
                        target="_blank"
                        rel="noopener noreferrer"
                      >{{this.localizationContent?.pay_now}}</a
                      >
                    </span>
                    </button>
                  </div>
                </div>
              </swiper-slide>

              <!--          without cost breakdown b2c-->

              <swiper-slide class="mb-6 p-2.5 bg-[#F8F8F8] rounded-[10px]" *ngIf="!this.data?.costSettings?.isDynamicPricing && this.data?.costing?.personCost !== 0 &&
            !this.data?.viewSettings.isTourCostHidden && this.data?.costing?.viewType !== 'custom' && this.isClientUrl">
                <div class="min-h-[11rem]">
                  <p class="text-[#B7B7B7] font-normal text-[1.5rem]">{{ this.data?.costing?.viewType === 'person' ? this.localizationContent?.cost_per_person : this.localizationContent?.total_tour_cost}}</p>
                  <div>
                    <div class="flex md:flex-col flex-row leading-9 mb-3">
                      <p>
                        {{ this.data?.tour?.currency }}
                        <span class="font-semibold">
                          {{
                            (this.data?.costing?.viewType === 'person' ? this.data?.costing?.personCost : this.data?.costing?.grandTotal) | number:'1.2-2'
                          }}
                        </span>
                      </p>
                    </div>
                  <div
                    *ngIf="!this.data?.viewSettings.isPaymentLinkChecked && this.data?.paymentLink !=='' && this.data?.paymentLink !==null">
                    <button
                      class="payment-button">
                    <span>
                      <a
                        href="{{ this.data?.paymentLink }}"
                        target="_blank"
                        rel="noopener noreferrer"
                      >{{this.localizationContent?.pay_now}}</a
                      >
                    </span>
                    </button>
                  </div>
                  </div>
                </div>
              </swiper-slide>

              <!--          with cost breakdown b2c-->
              <swiper-slide class="mb-6 p-2.5 bg-[#F8F8F8] rounded-[10px]"
                            *ngIf="!this.data?.costSettings?.isDynamicPricing && !this.data?.viewSettings.isTourCostHidden && this.data?.b2b?.costing?.viewType ==='custom' && !this.isClientUrl">
                <div class="min-h-[8.2rem]">
                  <p class="text-[#B7B7B7] font-normal text-[1.5rem]">{{this.localizationContent?.cost_per_person}}</p>
                  <div class="flex flex-col md:flex-row mt-3">
                    <div class="flex md:flex-col flex-row leading-7">
                      <p>
                        {{ this.data?.tour?.currency }}
                        <span class="font-semibold">{{
                            this.data?.b2b?.costing?.costPerAdult | number:'1.2-2'
                          }}</span>
                      </p>
                      <span
                        class="ml-3 md:ml-0 mt-3 md:mt-0 font-light flex justify-start md:justify-end items-center text-[#454545] text-[12px]"
                      >{{this.localizationContent?.per_adult}}</span
                      >
                    </div>
                    <div class="flex md:flex-col flex-row leading-7">
                      <p>
                        {{ this.data?.tour?.currency }}
                        <span class="font-semibold">{{
                            this.data?.b2b?.costing?.costPerChild | number:'1.2-2'
                          }}</span>
                      </p>
                      <span
                        class="ml-3 md:ml-0 mt-3 md:mt-0 font-light flex justify-start md:justify-end items-center text-[#454545] text-[12px]"
                      >{{this.localizationContent?.per_child}</span
                      >
                    </div>
                    <div class="flex md:flex-col flex-row leading-7">
                      <p>
                        {{ this.data?.tour?.currency }}
                        <span class="font-semibold">{{
                            this.data?.b2b?.costing?.costPerInfant  | number:'1.2-2'
                          }}</span>
                      </p>
                      <span
                        class="ml-3 md:ml-0 mt-3 md:mt-0 font-light flex justify-start md:justify-end items-center text-[#454545] text-[12px]"
                      >{{this.localizationContent?.per_infant}}</span
                      >
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <!--          without cost breakdown b2b-->
              <swiper-slide class="mb-6 p-2.5 bg-[#F8F8F8] rounded-[10px]" *ngIf="!this.data?.costSettings?.isDynamicPricing &&
            (this.data?.b2b?.costing?.personCost !== 0 || this.data?.b2b?.costing?.grandTotal !== 0) &&
            !this.data?.viewSettings.isTourCostHidden && this.data?.b2b?.costing?.viewType !=='custom' && !this.isClientUrl">
                <div class="min-h-[8.2rem]">
                  <p class="text-[#B7B7B7] font-normal text-[1.5rem]">
                    {{this.data?.b2b?.costing?.viewType === 'person' ? this.localizationContent?.cost_per_person : this.localizationContent?.total_tour_cost}}
                  </p>
                  <div class="flex md:flex-col flex-row leading-9">
                    <p>
                      {{ this.data?.tour?.currency }}
                      <span class="font-semibold">
                        {{
                          (this.data?.b2b.costing?.viewType === 'person' ? this.data?.b2b.costing?.personCost : this.data?.b2b.costing?.grandTotal) | number:'1.2-2'
                        }}
                      </span>
                    </p>
                  </div>
                </div>
              </swiper-slide>
            </swiper-container>
            <div>
              <div class="flex justify-between items-center w-full">
                <button (click)="goPrev()"
                        class="w-10 h-10 flex items-center justify-center border rounded-full text-blue-500 border-blue-500 hover:bg-blue-100">
                  <lucide-icon name="arrow-left"></lucide-icon>
                </button>

                <button (click)="goNext()"
                        class="w-10 h-10 flex items-center justify-center border rounded-full text-blue-500 border-blue-500 hover:bg-blue-100">
                  <lucide-icon name="arrow-right"></lucide-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="this.data?.tour?.type === 'B2B' && this.isClientUrl"
             class="px-8 rounded-[20px] bg-[#dedede]">
          <div class="w-full h-80 flex justify-center items-center">
            <p>Editable link allows the B2B travel agent to modify this section</p>
          </div>
        </div>

        <div *ngIf="!this.data?.viewSettings.isCompanyDetailsHidden">
          <div *ngIf="this.data?.tour?.type === 'B2B' && !this.isClientUrl" class="md:bg-white bg-[#F8F8F8] rounded-[20px] md:px-0 px-6 py-8">
            <div class="grid grid-cols-12 gap-5">
              <div class="md:col-span-7 col-span-12">
                <p class="text-[#B7B7B7] font-normal text-[1.5rem] mb-3">{{this.localizationContent?.company}}</p>
                <div class="grid grid-cols-1 space-y-4">
                  <div>
                    <h4 class="text-[#454545]">
                      {{ this.data?.b2b?.customer?.companyName }}
                    </h4>
                  </div>
                  <div>
                    <p class="text-justify">
                      {{ this.data?.b2b?.customer?.summary }}
                    </p>
                  </div>
                  <div class="flex flex-row justify-between">
                    <img *ngIf="this.data?.b2b?.customer?.logo" loading="lazy"
                         class="lg:w-[20rem] md:w-[15rem] w-[8rem] h-[4rem] object-contain object-left"
                         [src]="this.data?.b2b?.customer?.logo"
                         alt="Company Logo" />
                    <div class="flex md:mt-0 mt-3  gap-5">
                      <div
                        *ngIf="!this.data?.viewSettings.isWebsiteLinkChecked && this.data?.b2b?.customer?.websiteLink !== '' && this.data?.b2b?.customer?.websiteLink !== null">
                        <button
                          class="md:px-16 px-8 md:py-4  py-2 border rounded-[1.25rem] border-black border-solid">
                              <span class="font-semibold text-lg text-[#202A49]">
                                <a
                                  class="hover:no-underline hover:text-[#202A49] capitalize"
                                  href="{{
                                    this.data?.b2b?.customer?.websiteLink
                                  }}"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >{{this.localizationContent?.visit_website}}
                                </a>
                              </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="md:block hidden md:col-span-5 col-span-12  bg-gray-300">
              </div>
            </div>
          </div>
        </div>

        <!-- company information  start of b2b-->
<!--        <div *ngIf="!this.data?.viewSettings.isCompanyDetailsHidden">-->
<!--          <div *ngIf="this.data?.tour?.type  === 'B2B' && this.isClientUrl && this.determineToShow()"-->
<!--               class="md:bg-white bg-[#F8F8F8]">-->
<!--            <div class="grid grid-cols-12 ">-->
<!--              <div class="lg:col-span-4 md:col-span-6 col-span-12">-->
<!--                <div *ngIf="this.data?.b2b?.customer?.logo">-->
<!--                  <img loading="lazy"-->
<!--                    class="w-[21.75rem] h-[5.125rem] object-contain object-center"-->
<!--                    [src]="this.data?.b2b?.customer?.logo"-->
<!--                    alt="Company Logo" />-->
<!--                </div>-->
                <!--                <h4 class="text-[#454545] hidden md:block">-->
                <!--                  {{ this.data?.b2b?.customer?.companyName }}-->
                <!--                </h4>-->
                <!--                <h5 class="text-[#454545] md:hidden block">-->
                <!--                  {{ this.data?.b2b?.customer?.companyName }}-->
                <!--                </h5>-->
<!--              </div>-->
<!--              <div class="lg:col-span-7  md:col-span-6 col-span-12">-->
<!--                <p class="text-justify">-->
<!--                  {{ this.data?.b2b?.customer?.summary }}-->
<!--                </p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <!--     end of b2b-->

        <div *ngIf="this.data?.costSettings?.isDynamicPricing && !this.data?.viewSettings.isTourCostHidden">
          <div>
            <div
              class="flex flex-col md:flex-row justify-between md:items-center">
              <div>
                <p class="text-[#B7B7B7] font-normal text-[1.5rem] mb-3">{{this.localizationContent.seasonal_pricing}}</p>
              </div>
            </div>
            <div>
              <table class="min-w-full text-left border-separate border-spacing-y-2 mb-8">
                <thead class="text-[#1E293B] text-[11px] font-normal bg-[#DADADA]">
                <tr class="text-center">
                  <th
                    class="py-3 px-4 min-w-20"
                    *ngFor="let header of data?.costing?.dynamicPricing?.headers">
                    {{ header.name }}
                  </th>
                </tr>
                </thead>

                <tbody class="text-[11px] text-center text-[#1E293B]">
                <tr
                  class="bg-white shadow-sm rounded-md"
                  *ngFor="let row of data?.costing?.dynamicPricing?.rows">
                  <td
                    class="py-3 px-4 min-w-20"
                    *ngFor="let cell of row; let i = index">
                    {{ getCellDisplay(i, cell) }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div *ngIf="
            !this.data?.viewSettings.isPricingRemarksChecked &&
            this.data?.costing?.pricingRemarks !== ''  &&
            this.data?.costing?.pricingRemarks !== null">
          <div class="md:bg-white bg-[#F8F8F8] rounded-[20px] md:px-0 px-6 py-8">
            <p class="text-[#B7B7B7] font-normal text-[1.5rem] mb-3">{{this.localizationContent?.special_notes}}</p>
            <div class="my-[10px] prose" [innerHTML]="data?.costing.pricingRemarks"></div>
          </div>
        </div>

        <!-- company information  start of b2c-->
        <div *ngIf="!this.data?.viewSettings.isCompanyDetailsHidden">
          <div *ngIf="this.data?.tour?.type === 'B2C' && this.isClientUrl" class="md:bg-white bg-[#F8F8F8] rounded-[20px] md:px-0 px-6 py-8">
            <div class="grid grid-cols-12 gap-10">
              <div class="md:col-span-7 col-span-11">
                <p class="text-[#B7B7B7] font-normal text-[1.5rem] mb-3">{{this.localizationContent?.company}}</p>
                <div class="grid grid-cols-1 space-y-4">
                  <div>
                    <h4 class="text-[#454545]">
                      {{ this.organizationSetting?.companyName }}
                    </h4>
                  </div>
                  <div>
                    <p class="text-justify break-words">
                      {{ this.organizationSetting?.companyDetails?.summary }}
                    </p>
                  </div>
                  <div class="flex flex-row justify-between">
                    <img loading="lazy"
                         class="lg:w-[20rem] md:w-[15rem] w-[8rem] h-[4rem] object-contain object-left"
                         [src]="this.organizationSetting?.logo"
                         alt="Company Logo" />
                    <div class="flex md:mt-0 mt-3  gap-5">
                      <div
                        *ngIf="!this.data?.viewSettings.isWebsiteLinkChecked">
                        <button
                          class="md:px-16 px-8 md:py-4  py-2 border rounded-[1.25rem] border-black border-solid">
                              <span class="font-semibold text-lg text-[#202A49]">
                                <a
                                  class="hover:no-underline hover:text-[#202A49] capitalize"
                                  href="{{
                                    this.organizationSetting?.companyDetails?.websiteLink
                                  }}"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >{{this.localizationContent?.visit_website}}
                                </a>
                              </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="md:col-span-5 col-span-12" *ngIf="!this.data?.viewSettings.isTourOperatorHidden">
                <p class="text-[#B7B7B7] font-normal text-[1.5rem] mb-3"> {{this.tourOperatorTitle}}</p>
                <div class="grid grid-cols-1 space-y-10">
                    <div class="mb-4 flex flex-row  items-center">
                      <div *ngIf="this.data?.creator[0].profile" class="pr-5">
                        <img loading="lazy"
                             class="rounded-full object-cover w-32 h-32"
                             [src]="this.data?.creator[0].profile"
                             alt="profile" />
                      </div>
                      <div class="flex flex-col">
                        <span class="font-medium text-[1.5rem] ">
                          {{ this.data?.creator[0].name }}
                        </span>
                        <div class="flex flex-row my-3 items-center">
                          <lucide-icon
                            class="aboutus-subheader-icon flex"
                            name="at-sign"></lucide-icon>
                          <span class="ps-2 text-[#444444]">
                          <a
                            href="mailto:{{this.data?.creator[0].email}}?subject=Travsta Operator -
                            {{this.data?.creator[0].name}}">{{ this.data?.creator[0].email }}
                          </a>
                        </span>
                        </div>
                        <div class="flex flex-row items-center">
                          <lucide-icon
                            class="aboutus-subheader-icon flex"
                            name="phone"></lucide-icon>
                          <span class="ps-2 text-[#444444]">
                            {{ this.data?.creator[0]?.dialCode || "" }} {{ this.data?.creator[0].mobile }}
                          </span>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              <div class="md:block hidden col-span-5 bg-gray-300" *ngIf="this.data?.viewSettings.isTourOperatorHidden">
              </div>
            </div>
          </div>
        </div>
        <!--     end of b2c-->

        <div class="space-y-[20px]" *ngIf="this.data?.featured?.description">
          <h2>{{this.localizationContent?.overview}}</h2>
          <div class="grid grid-cols-12">
            <div class="lg:col-span-9 col-span-12">
              <p class="text-[#444444]" [innerHTML]="this.data?.featured?.description"></p>
            </div>
          </div>
        </div>

        <div class="space-y-[20px]">
          <div class="overflow-x-auto">
            <table class="min-w-full text-left border-separate border-spacing-y-2">
              <thead>
              <tr class="text-[#1E293B] md:text-xl text-base font-normal bg-[#DADADA]">
                <th class="px-2 py-2 min-w-[80px]">{{this.localizationContent?.day}}</th>
                <th class="px-2 py-2 min-w-[120px]">{{this.localizationContent?.date}}</th>
                <th class="px-2 py-2 min-w-[120px]">{{this.localizationContent?.accommodation}}</th>
                <th class="px-2 py-2 min-w-[110px]">{{this.localizationContent?.destination}}</th>
                <th class="px-2 py-2 min-w-[200px]">{{this.localizationContent?.rooms}}</th>
              </tr>
              </thead>
              <tbody class="md:text-xl text-base text-[#444444]">
              <tr *ngFor="let day of data?.days; let i = index" class="bg-white shadow-sm rounded-md">
                <td class="px-2 py-2 break-words whitespace-normal min-w-[80px]">Day {{ i + 1 | number : '2.0' }}</td>
                <td class="px-2 py-2 break-words whitespace-normal min-w-[120px]">{{ !this.data.tour.isDatesOptional ? ( day.date  | date: 'd MMM y'  | uppercase) : '-' }}</td>
                <ng-container *ngIf="!day?.isLeisureDay">
                  <ng-container *ngIf="(!this.data?.viewSettings?.isDepartureChecked ||
                    i !== this.data?.days.length - 1) else altDepartureRow;">
                  <ng-container *ngIf="this.getAccommodationPerDate(day.date, this.data.accommodation).length !== 0 else altAcc">
                    <td class="px-2 py-2 break-words whitespace-normal min-w-[120px]">{{this.getAccommodationPerDate(day.date, this.data.accommodation)[0].name}}</td>
                    <td class="px-2 py-2 break-words whitespace-normal min-w-[110px]">{{day.destination ? this.displayTitle(day?.destination?.titles, this.data.tour.language) : "-" }}</td>
                    <td class="px-2 py-2 break-words whitespace-normal min-w-[200px]">
                      <ng-container *ngIf="getAccommodationPerDate(day.date, data.accommodation)[0]?.rooms?.length > 0; else noRooms">
                        <div *ngFor="let room of this.getAccommodationPerDate(day.date, this.data.accommodation)[0]?.rooms; let i = index">
                          <span>
                            {{
                              (room.noOfRooms | number : '2.0') + ' x ' + (room?.roomCategory ? (room?.roomCategory | titlecase) : "") + " " +
                              (room?.roomType | titlecase) +
                              ' (' +
                              room?.mealType +
                              ')'
                            }}
                          </span>
                        </div>
                      </ng-container>
                      <ng-template #noRooms>
                        <span> - </span>
                      </ng-template>
                    </td>
                  </ng-container>
                  <ng-template #altAcc>
                    <td class="px-2 py-2 break-words whitespace-normal min-w-[120px]"> - </td>
                    <td class="px-2 py-2 break-words whitespace-normal min-w-[110px]">{{day.destination ? this.displayTitle(day?.destination?.titles, this.data.tour.language) : "-" }}</td>
                    <td class="px-2 py-2 break-words whitespace-normal min-w-[200px]"> - </td>
                  </ng-template>
                  </ng-container>
                  <ng-template #altDepartureRow>
                    <td colspan="3" class="px-2 py-2 break-words whitespace-normal ">{{this.localizationContent?.departure}}</td>
                  </ng-template>
                </ng-container>
                <ng-container *ngIf="day?.isLeisureDay">
                  <td colspan="3" class="px-2 py-2 break-words whitespace-normal">{{this.localizationContent?.leisure_day}}</td>
                </ng-container>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div *ngIf="this.data?.viewSettings.isDisplayMapTopsideChecked" class="space-y-[20px] mb-10">
          <div>
            <h3>{{this.localizationContent?.tour}} {{this.localizationContent?.map}}</h3>
          </div>
          <div class="flex justify-center bg-[#f8f8f8] rounded-[10px]">
            <img loading="lazy"
              class="object-contain md:h-[600px] h-auto"
              [src]="this.image"
              alt="map" />
          </div>
        </div>

        <div *ngIf="this.citiesByCountry.length !== 0"
             class=" space-y-[15px] md:hidden block">
          <div *ngFor="let data of this.citiesByCountry">
            <div class="flex flex-col space-y-[20px]">
              <div class="flex flex-col lg:flex-row lg:items-center">
              <span
                class="text-[#454545] font-semibold">
                {{ data.country }}
              </span>
                <div class="flex flex-col">
                  <div class="flex flex-wrap">
                    <div *ngFor="let city of data.cities; let i = index">
                      <p class="text-[#666666] pe-2">
                        {{ city }}
                        <span *ngIf="i < data.cities.length - 1">, </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!this.data?.viewSettings?.isThumbnailChecked"
          class="space-y-[25px]">
          <div class="flex flex-row gap-5 justify-end items-center w-full">
            <button (click)="goTourPrev()"
                    class="w-10 h-10 flex items-center justify-center border rounded-full text-blue-500 border-blue-500 hover:bg-blue-100">
              <lucide-icon name="arrow-left"></lucide-icon>
            </button>

            <button (click)="goTourNext()"
                    class="w-10 h-10 flex items-center justify-center border rounded-full text-blue-500 border-blue-500 hover:bg-blue-100">
              <lucide-icon name="arrow-right"></lucide-icon>
            </button>
          </div>
        <div>
          <swiper-container #swiperTourDayRef class="swiper-tour-days"
            space-between="15"
                            breakpoints='{
              "320":  { "slidesPerView": 1 },
              "640":  { "slidesPerView": 3 },
              "1024": { "slidesPerView": 4 }
            }'
            pagination="true" allow-touch-move="false" simulate-touch="false"

            speed="250"
            loop="false">
            <swiper-slide
              class="mb-8"
              *ngFor="let day of data.days; let i =index ">
              <div *ngIf="day.destination" (click)="this.navigateToDay(i)"
                class="relative w-full max-w-lg h-64 rounded-2xl overflow-hidden shadow-lg thumbnail-title hover:cursor-pointer">
                <ng-container *ngIf="
                    (!this.data?.viewSettings?.isDepartureChecked ||
                  i !== this.data?.days.length - 1); else altDepture">
                  <ng-container *ngIf="!day?.isLeisureDay">
                    <img loading="lazy"
                         [src]="day?.featuredDestination?.image ? day?.featuredDestination?.image : placeholderPath"
                         [alt]="day?.featuredDestination?.name"
                         class="absolute inset-0 w-full h-full object-cover"
                    />

                    <!-- dark overlay -->
                    <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                    <!-- text -->
                    <div class="absolute bottom-6 left-6 z-10">
                      <h3 class="text-3xl md:text-4xl leading-tight drop-shadow-md">{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h3>
                      <p class="mt-1 ">{{
                          this.displayTitle(
                            day?.destination?.titles,
                            this.data.tour.language
                          )
                        }}
                      </p>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="day?.isLeisureDay">
                    <img loading="lazy"
                         src="./assets/img/leisure_day.jpg"
                         [alt]="'Leisure Day'"
                         class="absolute inset-0 w-full h-full object-cover"
                    />
                    <!-- dark overlay -->
                    <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                    <!-- text -->
                    <div class="absolute bottom-6 left-6 z-10">
                      <h3 class="text-3xl md:text-4xl leading-tight drop-shadow-md">{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h3>
                      <p class="mt-1">
                        {{this.localizationContent?.leisure_day}}
                      </p>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-template #altDepture>
                  <img loading="lazy"
                       src="./assets/img/departure.jpg"
                       [alt]="'Leisure Day'"
                       class="absolute inset-0 w-full h-full object-cover"
                  />
                  <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                  <!-- text -->
                  <div class="absolute bottom-6 left-6 z-10">
                    <h3 class="text-3xl md:text-4xl leading-tight drop-shadow-md">{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h3>
                    <p class="mt-1">
                      {{this.localizationContent?.departure}}
                    </p>
                  </div>
                </ng-template>
              </div>
              <div *ngIf="!day.destination" (click)="this.navigateToDay(i)"
                   class="relative w-full max-w-lg h-64 rounded-2xl overflow-hidden shadow-lg thumbnail-title hover:cursor-pointer">
                <ng-container  *ngIf="
                    (!this.data?.viewSettings?.isDepartureChecked || i !== this.data?.days.length - 1); else altDepture">
                  <ng-container *ngIf="day?.isLeisureDay">
                    <img loading="lazy"
                         src="./assets/img/leisure_day.jpg"
                         [alt]="'depatuure'"
                         class="absolute inset-0 w-full h-full object-cover"
                    />
                    <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                          <!-- text -->
                          <div class="absolute bottom-6 left-6 z-10">
                            <h3 class="text-3xl md:text-4xl leading-tight drop-shadow-md">{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h3>
                            <p class="mt-1">
                              {{this.localizationContent?.leisure_day}}
                            </p>
                          </div>
                    </ng-container>
                  <ng-container *ngIf="!day?.isLeisureDay">
                    <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                    <!-- text -->
                    <div class="absolute bottom-6 left-6 z-10">
                      <h3 class="text-3xl md:text-4xl leading-tight drop-shadow-md">{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h3>
                      <p class="mt-1 h-8">
                      </p>
                    </div>
                  </ng-container>
                  </ng-container>
                  <ng-template #altDepture>
                    <img loading="lazy"
                         src="./assets/img/departure.jpg"
                         [alt]="'depatuure'"
                         class="absolute inset-0 w-full h-full object-cover"
                    />
                    <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                    <!-- text -->
                    <div class="absolute bottom-6 left-6 z-10">
                      <h3 class="text-3xl md:text-4xl leading-tight drop-shadow-md">{{this.localizationContent?.day}} {{ i + 1 | number : '2.0' }}</h3>
                      <p class="mt-1">
                        {{this.localizationContent?.departure}}
                      </p>
                    </div>
                  </ng-template>
                </div>
            </swiper-slide>
          </swiper-container>
        </div>
        </div>
        <div
          class="space-y-[25px]"
          *ngFor="let day of data?.days; let i = index">
          <nz-divider></nz-divider>
          <div
            *ngIf="
                (!this.data?.viewSettings?.isDepartureChecked ||
                  i !== this.data?.days.length - 1);
              else isDepartureBlock
            ">
            <ng-container *ngIf="!day.isMerged; else altMerge">
              <div>
                <div class="grid grid-cols-12 mb-8 gap-5">
                  <div class="lg:col-span-5 col-span-12" [id]="'day-' + i">
                    <h1 style="line-height: 70px">
                      {{this.localizationContent?.day}} <span class="md:text-[130px] text-[64px] ">{{ i + 1 | number : '2.0' }}</span>
                    </h1>
                    <div class="flex flex-col items-start md:mt-5">
                      <h3 *ngIf="day.destination && !day?.isLeisureDay">
                        {{
                          this.displayTitle(
                            day?.destination?.titles,
                            this.data.tour.language
                          )
                        }}
                      </h3>
                      <h3 *ngIf="day?.isLeisureDay">
                        {{this.localizationContent?.leisure_day}}
                      </h3>
                      <span class="text-[#969696] md:text-[1.5rem] text-[1rem] font-light">
                      {{ !this.data.tour.isDatesOptional ? ( day.date | date: 'd MMM y' | uppercase) : "" }}
                    </span>
                    </div>
                  </div>
                  <div *ngIf="!day?.isLeisureDay" class="lg:col-span-7 col-span-12">
                    <p class="text-[#444444] text-left md:block hidden">
                      {{ day?.featuredDestination?.body }}
                    </p>
                    <div class="block md:hidden">
                      <p class="truncate-lines" [innerHTML]="day?.featuredDestination?.body"></p>
                      <div *ngIf="!isStringLengthLessThanLimit(day?.featuredDestination?.body || '', limit.mdScreen)">
                      <span class="text-xl text-[#1278BA] cursor-pointer"
                            (click)="this.viewContent(
                          day?.featuredDestination?.body,
                          this.displayTitle(day?.destination?.titles, this.data.tour.language)
                        )">
                        {{this.localizationContent?.see_more}}
                      </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="day.destination && !day?.isLeisureDay" class="grid grid-cols-1">
                <div>
                  <img loading="lazy" *ngIf="day?.featuredDestination?.image"
                       class="w-full object-cover rounded-[10px] h-[14rem] md:h-[31rem]"
                       [src]="
                    day?.featuredDestination?.image
                      ? day?.featuredDestination?.image
                      : placeholderPath
                  "
                       [alt]="day?.destination?.city" />
                </div>
              </div>
            </ng-container>
            <ng-template #altMerge>
              <div class="grid grid-cols-12 mb-8 gap-5">
                <div class="lg:col-span-5 col-span-12" [id]="'day-' + i">
                <h1 style="line-height: 70px">
                  {{this.localizationContent?.day}} <span class="md:text-[130px] text-[64px]">{{ i + 1 | number : '2.0' }}</span>
                </h1>
                <div class="flex flex-col items-start md:mt-5">
                  <h3 *ngIf="day.destination && !day?.isLeisureDay">
                    {{
                      this.displayTitle(
                        day?.destination?.titles,
                        this.data.tour.language
                      )
                    }}
                  </h3>
                  <h3 *ngIf="day?.isLeisureDay">
                    {{this.localizationContent?.leisure_day}}
                  </h3>
                  <span class="text-[#969696] md:text-[1.5rem] text-[1rem] font-light">
                      {{ !this.data.tour.isDatesOptional ? ( day.date | date: 'd MMM y' | uppercase) : "" }}
                    </span>
                </div>
              </div>
              </div>
            </ng-template>
          </div>
          <ng-template #isDepartureBlock>
            <div class="grid md:grid-cols-2 grid-cols-1 mb-5">
              <div [id]="'day-' + i">
                <h1>{{this.localizationContent?.day}} <span class="md:text-[130px] text-[64px] ">{{ i + 1 | number : '2.0' }}</span>
                </h1>
                   <span class="text-[#969696] md:text-[1.5rem] text-[1rem] font-light">
                      {{ !this.data.tour.isDatesOptional ? ( day.date | date: 'd MMM y' | uppercase) : "" }}
                    </span>
              </div>

            </div>
            <div class="flex justify-end  bg-[#DADADA] md:min-h-[400px] min-h-[178px] rounded-[10px]">
              <span
                class="font-light lg:text-[12rem] md:text-[11rem] text-[3rem] flex items-end  text-[#FFFFFF]">{{this.localizationContent?.departure}}</span>
            </div>
          </ng-template>

          <!-- Experience md screens greater -->
          <div
            class="space-y-[20px] hidden lg:block"
            *ngIf="
              data.experiences[i]?.experiencesPerDay[0]?.experience !== undefined && data.experiences[i]?.experiencesPerDay.length !== 0  && !day?.isLeisureDay
            ">
            <h3>{{this.localizationContent?.experiences}}</h3>
            <div class="grid grid-cols-2 gap-5" *ngIf="data.experiences[i].experiencesPerDay.length > 1 else altExpStructure">
              <div class="grid grid-cols-12 gap-3" *ngFor="let exp of data.experiences[i].experiencesPerDay">
                <div class="col-span-5 relative w-full mb-6" *ngIf="exp?.featuredExperience?.image">
                  <img loading="lazy"
                    *ngIf="exp?.featuredExperience?.image"
                    class="object-cover rounded-xl h-[12rem] w-full"
                    [src]="exp?.featuredExperience?.image"
                    alt="Featured experience image"
                  />
                  <div *ngIf="!this.data?.viewSettings.isExperiencesNoteChecked && exp?.notes !==''" class="absolute top-2 right-2 z-10">
                    <nz-icon  nz-tooltip
                              nzTooltipPlacement = 'left'
                              [nzTooltipArrowPointAtCenter]="true"
                              [nzTooltipTitle]="exp?.notes"
                              [nzTooltipOverlayStyle]="{
                        'max-width': '400px',
                        'min-width': '300px',
                        'white-space': 'normal',
                        'line-height': '1.5'
                      }"
                              nz-icon nzType="info-circle" class="w-6 h-6 text-black bg-white/80 rounded-md shadow-md flex justify-center items-center " nzTheme="outline">
                    </nz-icon>
                  </div>
                  <div *ngIf="!this.data?.viewSettings.isIncludeBadgeChecked && exp?.conditionType === 'INC' "
                       class="absolute bottom-4 right-4 z-10">
                    <span class="w-full rounded-full px-3 py-1 text-green-600 bg-green-200 border border-green-600 capitalize">
                      {{'Included'}}
                    </span>
                  </div>
                  <div *ngIf="!this.data?.viewSettings.isExcludeBadgeChecked && exp?.conditionType === 'EXC' "
                       class="absolute bottom-4 right-4 z-10">
                    <span class="w-full rounded-full px-3 py-1 text-red-600 bg-red-200 border border-red-600 capitalize">
                      {{'Excluded'}}
                    </span>
                  </div>
                </div>
                <div class="col-span-7">
                  <div class="flex flex-row gap-2 items-center" *ngIf="exp?.isCustomTitle">
                    <h5  class="my-3 text-[#202A49]">
                      {{
                        exp?.customTitle
                      }}
                    </h5>
                    <ng-container *ngIf="exp?.customUrl !== ''">
                      <a [href]="exp?.customUrl" target="_blank"
                         rel="noopener noreferrer">
                        <lucide-icon name="square-arrow-out-up-right" class="flex exp-url-icon"></lucide-icon>
                      </a>
                    </ng-container>
                  </div>

                  <div class="flex flex-row gap-2 items-center" *ngIf="!exp?.isCustomTitle">
                    <h5  class="my-3 text-[#202A49]">
                      {{
                        this.displayTitle(
                          exp?.experience?.titles || [],
                          this.data.tour.language
                        )
                      }}
                    </h5>
                    <ng-container *ngIf="exp?.customUrl !== ''">
                      <a [href]="exp?.customUrl" target="_blank"
                         rel="noopener noreferrer">
                        <lucide-icon name="square-arrow-out-up-right" class="flex exp-url-icon"></lucide-icon>
                      </a>
                    </ng-container>
                  </div>
                  <div>
                    <div
                      class="text-[#444444] truncate-lines"
                      [innerHTML]="
                      exp?.featuredExperience?.body
                    "></div>
                    <div
                      *ngIf="
                      !isStringLengthLessThanLimit(
                        exp?.featuredExperience?.body || '',
                        limit.lScreen
                      )
                    ">
                    <span
                      class="text-[#1278BA] cursor-pointer"
                      (click)="
                        this.viewContent(
                          exp?.featuredExperience?.body,
                          this.displayTitle(
                            exp.experience.titles,
                            this.data.tour.language
                          )
                        )
                      ">
                      {{this.localizationContent?.see_more}}
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #altExpStructure>
              <div class="grid grid-cols-12 gap-3" *ngFor="let exp of data.experiences[i].experiencesPerDay">
                <div class="col-span-4 relative w-full mb-6" *ngIf="exp?.featuredExperience?.image">
                  <img loading="lazy"
                       *ngIf="exp?.featuredExperience?.image"
                       class="object-cover rounded-xl h-[18rem] w-full"
                       [src]="exp?.featuredExperience?.image"
                       alt="Featured experience image"
                  />
                  <div *ngIf="!this.data?.viewSettings.isExperiencesNoteChecked && exp?.notes !==''" class="absolute top-2 right-2 z-10">
                    <nz-icon  nz-tooltip
                              nzTooltipPlacement = 'left'
                              [nzTooltipArrowPointAtCenter]="true"
                              [nzTooltipTitle]="exp?.notes"
                              [nzTooltipOverlayStyle]="{
                        'max-width': '400px',
                        'min-width': '300px',
                        'white-space': 'normal',
                        'line-height': '1.5'
                      }"
                              nz-icon nzType="info-circle" class="w-6 h-6 text-black bg-white/80 rounded-md shadow-md flex justify-center items-center " nzTheme="outline">
                    </nz-icon>
                  </div>
                  <div *ngIf="!this.data?.viewSettings.isIncludeBadgeChecked && exp?.conditionType === 'INC' "
                       class="absolute bottom-4 right-4 z-10">
                    <span class="w-full rounded-full px-3 py-1 text-green-600 bg-green-200 border border-green-600 capitalize">
                      {{'Included'}}
                    </span>
                  </div>
                  <div *ngIf="!this.data?.viewSettings.isExcludeBadgeChecked && exp?.conditionType === 'EXC' "
                       class="absolute bottom-4 right-4 z-10">
                    <span class="w-full rounded-full px-3 py-1 text-red-600 bg-red-200 border border-red-600 capitalize">
                      {{'Excluded'}}
                    </span>
                  </div>
                </div>
                <div class="col-span-8">
                  <div class="flex flex-row gap-2 items-center" *ngIf="exp?.isCustomTitle">
                    <h5  class="my-3 text-[#202A49]">
                      {{
                        exp?.customTitle
                      }}
                    </h5>
                    <ng-container *ngIf="exp?.customUrl !== ''">
                      <a [href]="exp?.customUrl" target="_blank"
                         rel="noopener noreferrer">
                        <lucide-icon name="square-arrow-out-up-right" class="flex exp-url-icon"></lucide-icon>
                      </a>
                    </ng-container>
                  </div>
                  <div class="flex flex-row gap-2 items-center" *ngIf="!exp?.isCustomTitle">
                    <h5  class="my-3 text-[#202A49]">
                      {{
                        this.displayTitle(
                          exp?.experience?.titles || [],
                          this.data.tour.language
                        )
                      }}
                    </h5>
                    <ng-container *ngIf="exp?.customUrl !== ''">
                      <a [href]="exp?.customUrl" target="_blank"
                         rel="noopener noreferrer">
                        <lucide-icon name="square-arrow-out-up-right" class="flex exp-url-icon"></lucide-icon>
                      </a>
                    </ng-container>
                  </div>
                  <div>
                    <div
                      class="text-[#444444] truncate-lines"
                      [innerHTML]="
                      exp?.featuredExperience?.body
                    "></div>
                    <div
                      *ngIf="
                      !isStringLengthLessThanLimit(
                        exp?.featuredExperience?.body || '',
                        limit.lScreen
                      )
                    ">
                    <span
                      class="text-[#1278BA] cursor-pointer"
                      (click)="
                        this.viewContent(
                          exp?.featuredExperience?.body,
                          this.displayTitle(
                            exp.experience.titles,
                            this.data.tour.language
                          )
                        )
                      ">
                      {{this.localizationContent?.see_more}}
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
          <!-- Experience md screens lesser -->
          <div
            class="space-y-[20px] lg:hidden md:block"
            *ngIf="
              data.experiences[i]?.experiencesPerDay[0]?.experience !== undefined && data.experiences[i]?.experiencesPerDay.length !== 0 && !day?.isLeisureDay
            ">
            <h3>{{this.localizationContent?.experiences}}</h3>
            <div>
              <swiper-container class="swiper-exp"
                space-between="15"
                slides-per-view="auto"
                pagination="true"
                speed="250"
                breakpoints='{
              "320": { "slidesPerView": 1.1, "spaceBetween": 10 },
              "768": { "slidesPerView": 2.1, "spaceBetween": 10 },
              "1024": { "slidesPerView": "auto", "spaceBetween": 15 }}'>
                <swiper-slide
                  class="mb-6"
                  *ngFor="let exp of data.experiences[i].experiencesPerDay">
                  <div>
                    <div class="relative w-full mb-6" *ngIf="exp?.featuredExperience?.image">
                      <img loading="lazy" *ngIf="exp?.featuredExperience?.image"
                           class="object-cover rounded-xl h-[14.438rem] md:h-60 w-full"
                           [src]="exp?.featuredExperience?.image"
                           alt="" />
                      <div *ngIf="!this.data?.viewSettings.isExperiencesNoteChecked && exp?.notes !==''" class="absolute top-2 right-2 z-10">
                        <nz-icon  nz-tooltip
                                  nzTooltipPlacement = 'left'
                                  [nzTooltipArrowPointAtCenter]="true"
                                  [nzTooltipTitle]="exp?.notes"
                                  [nzTooltipOverlayStyle]="{
                        'max-width': '400px',
                        'min-width': '300px',
                        'white-space': 'normal',
                        'line-height': '1.5'
                      }"
                                  nz-icon nzType="info-circle" class="w-6 h-6 text-black bg-white/80 rounded-md shadow-md flex justify-center items-center " nzTheme="outline">
                        </nz-icon>
                      </div>
                      <div *ngIf="!this.data?.viewSettings.isIncludeBadgeChecked && exp?.conditionType === 'INC' "
                           class="absolute bottom-4 right-4 z-10">
                    <span class="w-full rounded-full px-3 py-1 text-green-600 bg-green-200 border border-green-600 capitalize">
                      {{'Included'}}
                    </span>
                      </div>
                      <div *ngIf="!this.data?.viewSettings.isExcludeBadgeChecked && exp?.conditionType === 'EXC' "
                           class="absolute bottom-4 right-4 z-10">
                    <span class="w-full rounded-full px-3 py-1 text-red-600 bg-red-200 border border-red-600 capitalize">
                      {{'Excluded'}}
                    </span>
                      </div>
                    </div>
                    <div class="flex flex-row gap-2 items-center" *ngIf="exp?.isCustomTitle">
                      <h5  class="my-3 text-[#202A49]">
                        {{
                          exp?.customTitle
                        }}
                      </h5>
                      <ng-container *ngIf="exp?.customUrl !== ''">
                        <lucide-icon name="square-arrow-out-up-right" class="flex exp-url-icon"></lucide-icon>
                      </ng-container>
                    </div>
                    <div class="flex flex-row gap-2 items-center" *ngIf="!exp?.isCustomTitle">
                      <h5  class="my-3 text-[#202A49]">
                        {{
                          this.displayTitle(
                            exp?.experience?.titles || [],
                            this.data.tour.language
                          )
                        }}
                      </h5>
                      <ng-container *ngIf="exp?.customUrl !== ''">
                        <lucide-icon name="square-arrow-out-up-right" class="flex exp-url-icon"></lucide-icon>
                      </ng-container>
                    </div>
                    <div>
                      <div
                        class="text-xl text-[#444444] truncate-lines"
                        [innerHTML]="
                          exp?.featuredExperience?.body
                        ">
                      </div>
                      <div
                        *ngIf="
                          !isStringLengthLessThanLimit(
                            exp?.featuredExperience?.body || '',
                            limit.mdScreen
                          )
                        ">
                        <span
                          class="text-xl text-[#1278BA] cursor-pointer"
                          (click)="
                            this.viewContent(
                              exp?.featuredExperience?.body,
                              this.displayTitle(
                                exp.experience.titles,
                                this.data.tour.language
                              )
                            )
                          ">
                          {{this.localizationContent?.see_more}}
                        </span>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper-container>
            </div>
          </div>

          <!-- Accommodation -->
          <div
            *ngIf="getAccommodationPerDate(day.date, this.data.accommodation).length !== 0 && !day?.isLeisureDay"
            class="col-span-12 lg:col-span-4 space-y-[20px]">
            <h3>{{this.localizationContent?.accommodation}}</h3>
            <div
              *ngFor="
                    let accommodation of getAccommodationPerDate(day.date,this.data.accommodation)
                  "
              class="grid grid-cols-12 md:gap-8  gap-5">
              <div class="md:col-span-4 col-span-12" *ngIf="!this.data?.viewSettings.isHotelImageChecked">
                <ng-container *ngIf="!this.data?.viewSettings.isHotelImageChecked">
                  <div class="relative w-full">
                    <img loading="lazy"
                      class="w-full h-[14.25rem] md:h-[18rem] object-cover rounded-[10px]"
                      [src]="accommodation?.photoUri || placeholderPath"
                      alt="accommodation"
                    />
                    <div *ngIf="!this.data?.viewSettings.isAccommodationNoteChecked && accommodation.notes !== ''" class="absolute top-2 right-2 z-10">
                      <nz-icon  nz-tooltip
                                nzTooltipPlacement ='left'
                                [nzTooltipArrowPointAtCenter]="true"
                                [nzTooltipTitle]="accommodation?.notes"
                                [nzTooltipOverlayStyle]="{
                                      'max-width': '400px',
                                      'min-width': '300px',
                                      'white-space': 'normal',
                                      'line-height': '1.5'
                                    }"
                                nz-icon nzType="info-circle" class="w-6 h-6 text-black bg-white/80 rounded-md shadow-md flex justify-center items-center " nzTheme="outline">
                      </nz-icon>
                    </div>
                  </div>
                </ng-container>
              </div>
              <div class="md:col-span-6 col-span-12">
                <h4 class="text-[#444444]">{{ accommodation?.name }}</h4>
                <p
                  *ngIf="!this.data?.viewSettings.isHotelRatingChecked"
                  class="mb-3 font-medium text-primary">
                  {{ accommodation?.rating }} {{this.localizationContent?.star}}
                </p>
                <div class="flex flex-col">
                  <ng-container *ngIf="!this.data?.viewSettings.isAccommodationRoomsChecked">
                  <div
                    *ngFor="let room of accommodation?.rooms; let i = index">
                    <div class="flex">
                      <div class="flex flex-row items-center">
                        <lucide-icon
                          class="accommodation-subheader-icon flex mr-1"
                          name="bed-double"></lucide-icon>
                        <p
                          class="space-x-[10px] text-[#444444] mr-1 font-light">
                          {{
                            (room.noOfRooms | number : '2.0') + ' x ' + (room?.roomCategory ? (room?.roomCategory | titlecase) : "") + " " +
                            (room?.roomType | titlecase) +
                            ' (' +
                            room?.mealType +
                            ')'
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  </ng-container>
                  <ng-container *ngIf="!this.data?.viewSettings.isHotelDescriptionChecked">
                    <div class="my-3" *ngIf="accommodation?.hotelDescription">
                      <p>{{ accommodation?.hotelDescription }}</p>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!this.data?.viewSettings.isHotelWebsiteChecked">
                    <div class="flex" *ngIf="accommodation?.websiteUri">
                      <a
                        class="text-blue-900 hover:no-underline hover:text-[#202A49] capitalize"
                        href="{{
                        accommodation?.websiteUri
                      }}"
                        target="_blank"
                        rel="noopener noreferrer"
                      >{{this.localizationContent?.visit_website}}</a
                      >
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="day?.remarksTips && !this.data?.viewSettings?.isRemarksTipsChecked" class="space-y-[20px]">
            <h3>{{day?.remarksTitle ? day?.remarksTitle : "Day Highlights"}}</h3>
            <div>
              <p class="richtext-html-hyperlink" [innerHTML]="day?.remarksTips"></p>
            </div>
          </div>
          <div
            *ngIf="day.transport.length !== 0"
            class="space-y-[20px] hidden lg:block">
            <h3 class="mb-12">{{this.localizationContent?.transportation}}</h3>
            <app-transport-timeline class="preview-custom-two"  [transData]="day.transport" [viewType]="'web'" [data]="this.data">
            </app-transport-timeline>
          </div>
          <div
            *ngIf="day.transport.length !== 0"
            class="space-y-[40px] lg:hidden block">
            <h3 class="mb-12">{{this.localizationContent?.transportation}}</h3>
            <app-transport-timeline class="preview-custom-two"  [transData]="day.transport" [viewType]="'mobile'" [data]="this.data">
            </app-transport-timeline>
          </div>

        </div>
        <div *ngIf="!this.data?.viewSettings.isDisplayMapTopsideChecked" class="space-y-[20px] mb-10">
          <div>
            <h3>{{this.localizationContent?.tour}} {{this.localizationContent?.map}}</h3>
          </div>
          <div class="flex justify-center bg-[#f8f8f8] rounded-[10px]">
            <img loading="lazy"
              class="object-contain md:h-[600px] h-auto"
              [src]="this.image"
              alt="map" />
          </div>
        </div>
      </div>
    </div>
    <div class="bg-[#1D1D1D] w-full mt-10 ">
      <div class="container xl:max-w-[1280px] pt-12">
        <div
          class="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <!-- Inclusion -->
          <div *ngIf="data?.itinerary?.inclusions">
            <h2>{{this.localizationContent?.inclusion}}</h2>
            <div  class=" text-justify my-[10px] terms-inner-html-t2"
               [innerHTML]="data?.itinerary?.inclusions"></div>
          </div>
          <!-- Exclusion -->
          <div *ngIf="data?.itinerary?.exclusions">
            <h2>{{this.localizationContent?.exclusion}}</h2>
            <div class="text-justify my-[10px] terms-inner-html-t2"
               [innerHTML]="this.data?.itinerary?.exclusions"></div>
          </div>
        </div>
        <div
          class="grid grid-cols-1 gap-5">
          <!-- Cancellation Policy changed to Terms & Conditions -->
          <div class="mt-[20px]" *ngIf="data?.itinerary?.policies">
            <h2>{{this.localizationContent?.terms_and_conditions}}</h2>
            <div
              class="text-justify my-[10px] terms-inner-html-t2 truncate-lines-terms"
              [innerHTML]="this.data?.itinerary?.policies">
            </div>
            <div class="mt-2 mb-5"
              *ngIf="
                          !isStringLengthLessThanLimit(
                            this.data?.itinerary?.policies || '',
                            400
                          )
                        ">
                        <span
                          class="text-xl text-[#1278BA] cursor-pointer"
                          (click)="
                            this.viewContentInnerHtml(
                              this.data?.itinerary?.policies,
                             this.localizationContent?.terms_and_conditions
                            )
                          ">
                          {{this.localizationContent?.see_more}}
                        </span>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="this.countries.length !== 0"
        class="mb-2 bg-[#1D1D1D] overflow-hidden whitespace-nowrap md:block hidden">
        <div class="flex flex-wrap justify-center">
          <div *ngFor="let country of this.countries let i = index">
            <span class="pe-3 text-[150px] text-[#404040] font-light">
              {{ country }} <span *ngIf="i < this.countries.length - 1">, </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="container md:mt-10 mt-36">
      <div class="grid grid-cols-1">
        <div class="drop-shadow bottom-2 right-0 left-0 fixed z-50 w-full px-8 py-8 md:py-8 md:pb-0"
             *ngIf="this.data?.tour?.type  !== 'B2C' && !this.isClientUrl">
          <div class="py-5 px-10 bg-white text-center rounded-[10px]">
            <div
                 class="flex flex-col md:flex-row justify-center md:justify-between">
              <div class="flex justify-center items-end md:mb-0 mb-2">
                <h5>Agent Edit Panel</h5>
              </div>
              <div class="flex justify-center items-center" *ngIf="!this.isNotExpiredRealTime">
                <a><span class="text-[#6911D8] md:text-[1.25rem] text-[1rem]"
                         (click)="this.addEditCustomerInformation(this.data)">Change Information</span></a>
              </div>
              <div class="flex justify-center items-center">
                <a><span class="text-[#6911D8] md:text-[1.25rem] text-[1rem]"
                         (click)="this.generatePDF()">Download PDF</span></a>
              </div>
              <div class="flex justify-center items-center" *ngIf="this.data.isLinkExpirationEnabled">
                <span *ngIf="!this.isNotExpiredRealTime" class="text-[#6F6F6F] md:text-[1.25rem] text-[1rem]">Link Expires in {{ this.timeLeft }}</span>
                <span *ngIf="this.isNotExpiredRealTime" class="text-[#6F6F6F] md:text-[1.25rem] text-[1rem]">Link Expired</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</nz-spin>
